import { useMediaQuery } from "customHooks/useMediaQuery";
import React, { useEffect } from "react";

// components
import { LeftSide } from "./desktop/LeftSide";
import { MiddleSide } from "./desktop/MiddleSide";
import { RightSide } from "./desktop/RightSide";

// style
import "./styles.scss";
import { useSearchParams } from "react-router-dom";
import capitalizeFirstLetter from "helpers/cap";
import { elasticLog } from "helpers/elastic";

export const NewSeaerch = () => {
	const width = useMediaQuery();

	const isLaptopOrLower = width < 1080 ? true : false;

	const [searchParams, setSearchParams] = useSearchParams();
	useEffect(() => {
		const obj: any = {};
		searchParams.forEach((value, key) => {
			if (value) obj[key] = value;
		});
		obj["location"] = capitalizeFirstLetter(
			searchParams?.get("location") ||
				window.location.pathname?.split("/")[2]?.split("-")[2],
		);
		elasticLog({ index: "search-params", payload: obj });
	}, [searchParams]);

	return (
		<div className="new__search__container">
			{!isLaptopOrLower && <LeftSide />}
			<MiddleSide />
			{/* {!isLaptopOrLower && <RightSide />} */}
		</div>
	);
};
